import { defaultFormValues, FormValues } from "./FormValues";
import { Party } from "../enums/Party";
import { Gender } from "../enums/Gender";

export type EmployerFormValues = FormValues & {
    employeeSearch: string,
    newEmployee: boolean,
    privacyId: string,
    socialSecurityNumber: string,
    dateOfBirth: string,
    gender: Gender,
    streetAddress: string,
    city: string,
    state: string,
    zipCode: string,
    workState: string,
    workStateSameAsResidencyState: string,
    alternativeScheduleFrequency: string,
    averageDaysWorkedPerWeek: string,
    workersCompensation: string,
    dateOfHire: string,
    dateLastWorked: string,
    policyNumber: string,
    unitNumber: string,
    unitName: string,
    memberGroupName: string,
    employerName: string,
    employerContactName: string,
    employerPhoneNumber: string,
    employerEmailAddress: string,
    employerTitle: string
}

export const defaultEmployerFormValues = {
    ...defaultFormValues,
    party: Party.EMPLOYER,
    employeeSearch: '',
    newEmployee: false,
    privacyId: '',
    socialSecurityNumber: '',
    dateOfBirth: '',
    gender: '' as Gender,
    streetAddress: '',
    city: '',
    state: '',
    zipCode: '',
    workState: '',
    workStateSameAsResidencyState: '',
    alternativeScheduleFrequency: '',
    averageDaysWorkedPerWeek: '',
    workersCompensation: '',
    dateOfHire: '',
    dateLastWorked: '',
    policyNumber: '',
    unitNumber: '',
    unitName: '',
    memberGroupName: '',
    employerName: '',
    employerContactName: '',
    employerTitle: '',
    employerPhoneNumber: '',
    employerEmailAddress: ''
}
